'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { createPortal } from 'react-dom';
import { useState, useRef } from 'react';
import { useIsomorphicEffect } from '@s7/hooks';
import { useProps } from '@s7/styles';
import { isString } from '@s7/utils';
import { IDENT, defaultProps } from './Portal.contract.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Portal = function(props) {
    var _useProps = useProps(IDENT, defaultProps, props), _useProps_ = _useProps[0], target = _useProps_.target, children = _useProps_.children, className = _useProps_.className, innerRef = _useProps_.innerRef, others = _object_without_properties_loose(_useProps[0], [
        "target",
        "children",
        "className",
        "innerRef"
    ]);
    var _useState = useState(false), mounted = _useState[0], setMounted = _useState[1];
    var ref = useRef(null);
    useIsomorphicEffect(function() {
        setMounted(true);
        ref.current = !target ? document.createElement("div") : isString(target) ? document.querySelector(target) : target;
        if (!target) {
            document.body.appendChild(ref.current);
        }
        return function() {
            !target && document.body.removeChild(ref.current);
        };
    }, [
        target
    ]);
    if (!mounted) {
        return null;
    }
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ jsx("div", _extends({
        className: className
    }, others, {
        ref: innerRef,
        children: children
    })), ref.current);
};
Portal.displayName = IDENT;
var Portal$1 = Portal;

export { Portal, Portal$1 as default };
